import { patientList } from '@/service/h5-api'
const state = {
  patientListData: [],
  selectPatientData: {},
  editPatientData: {},
  signingPatientData: {}
};

const store = {
  namespaced: true,
  state,
  mutations: {
    SET_PATIENT_LIST_DATA(state, data) {
      state.patientListData = data
    },
    SET_SELECT_PATIENT(state, patient) {
      state.selectPatientData = patient
    },
    SET_EDIT_PATIENT(state, patient) {
      state.editPatientData = patient
    },
    SET_SIGNING_PATIENT(state, patient) {
      state.signingPatientData = patient
    }
  },
  actions: {
    getPatientList(state, addUserId) {
      patientList({
        addUserId
      }).then(({code, data}) => {
        state.commit('SET_PATIENT_LIST_DATA', data)
      })
    },
    selectPatient(state, patient) {
      state.commit('SET_SELECT_PATIENT', patient)
    },
    editPatient(state, patient) {
      state.commit('SET_EDIT_PATIENT', JSON.parse(JSON.stringify(patient)))
    },
    signingPatient(state, patient) {
      state.commit('SET_SIGNING_PATIENT', patient)
    }
  },
}
export default store;